export default __webpack_public_path__ + "static/media/DefaultImage.56bf58e2.png";